import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseWidgetModule } from '@fuse/components';
import { ChooseBoatDialogComponent } from '@shared/components/dialogs/choose-boat-dialog/choose-boat-dialog.component';
import { SharedModule } from '@shared/shared.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatDialogModule } from '@angular/material/dialog';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { DirectivesModule } from '@shared/directives/directives.module';
import { BcmDirectivesModule } from '@modules/bcm/@core/directives/bcm-directives.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { HtmlLinksModule } from '@modules/bcm/@shared/components/html-links/html-links.module';
import { MatSortModule } from '@angular/material/sort';
import { TranslationModule } from '@core/translation/translation.module';

@NgModule({
    declarations: [
        ChooseBoatDialogComponent
    ],
    imports: [
        MatDialogModule,
        MatSortModule,
        MatTableModule,
        MatButtonModule,
        MatToolbarModule,
        MatIconModule,
        MatFormFieldModule,
        MatInputModule,
        MatAutocompleteModule,
        MatProgressSpinnerModule,
        MatDatepickerModule,

        FuseSharedModule,
        FuseWidgetModule,

        SharedModule,
        DragDropModule,
        DirectivesModule,
        BcmDirectivesModule,
        MatCheckboxModule,
        HtmlLinksModule,
        TranslationModule,
    ],
})
export class ChooseBoatDialogModule {
}
